import React from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Icon } from "@iconify/react";
import roundClearAll from "@iconify/icons-ic/round-clear-all";
import { get_root_value } from "src/utils/domUtils";
import { DUE_DATE_OPTIONS } from "src/components/ClientReviews/clientReviewUtils";

/** Client reviews "Filters" drawer (same layout as the Members list filter). */
export default function ClientReviewsFilter({
  filterData,
  handleChangeOthers,
  searchSubmitFilter,
  handleClearFilter,
}) {
  return (
    <div className="container new-memories px-4">
      <FormControl fullWidth className="mt-3">
        <InputLabel id="client-reviews-due-date">Due date</InputLabel>
        <Select
          labelId="client-reviews-due-date"
          value={filterData.range}
          label="Due date"
          onChange={(e) => handleChangeOthers(e.target.value, "range")}
        >
          {DUE_DATE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {filterData.range === "custom" && (
        <>
          <TextField
            fullWidth
            type="date"
            label="From"
            className="mt-3"
            value={filterData.from}
            onChange={(e) => handleChangeOthers(e.target.value, "from")}
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: filterData.to || undefined }}
          />
          <TextField
            fullWidth
            type="date"
            label="To"
            className="mt-3"
            value={filterData.to}
            onChange={(e) => handleChangeOthers(e.target.value, "to")}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: filterData.from || undefined }}
          />
        </>
      )}

      <Box sx={{ py: 2 }}>
        <Button
          fullWidth
          size="large"
          type="submit"
          color="inherit"
          variant="outlined"
          onClick={searchSubmitFilter}
          startIcon={
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 5 }}
            >
              <path
                d="M13.1165 0.25H0.883548C0.321452 0.25 0.0378205 0.932013 0.436097 1.33029L5.3125 6.20743V11.6406C5.3125 11.8471 5.41325 12.0406 5.58242 12.1591L7.69179 13.6351C8.10794 13.9264 8.6875 13.6312 8.6875 13.1167V6.20743L13.564 1.33029C13.9615 0.932804 13.6798 0.25 13.1165 0.25Z"
                fill={get_root_value("--portal-theme-primary")}
              />
            </svg>
          }
        >
          Filter
        </Button>
      </Box>
      <Button
        fullWidth
        size="large"
        type="submit"
        color="inherit"
        variant="outlined"
        className="mb-3"
        onClick={handleClearFilter}
        startIcon={<Icon icon={roundClearAll} />}
      >
        Clear All
      </Button>
    </div>
  );
}
